module.exports = {
      id: "kenya-usage",
      viewBox: "0 0 24 16",
      url: __webpack_public_path__ + "sprite-dd90e0.smartcharts.svg#kenya-usage",
      toString: function () {
        return this.url;
      }
    }